import * as angular from "angular";

angular
    .module("whiteLabelTheme", ["ngMaterial"])
    .config(($mdThemingProvider: any) => {});
